import React from "react";
import { Link } from "react-router-dom";
import Brand from "../components/Brand";
import Countdown from "../components/Countdown";
import Faq from "../components/Faq";
import Waitlist from "../components/Waitlist";
import Footer from "../components/Footer";
import CookieBanner from "../components/CookieBanner";
import Reveal from "../components/Reveal";
import ExitIntentModal from "../components/ExitIntentModal";
import StickyMobileCta from "../components/StickyMobileCta";

const Landing = () => {
  return (
    <>
      <nav className="xnav" data-testid="nav">
        <div className="wrap nav-in">
          <Brand />
          <div className="nav-links">
            <a href="#how" data-testid="nav-how-link">How it works</a>
            <a href="#timeline" data-testid="nav-timeline-link">Launch</a>
            <a href="#faq" data-testid="nav-faq-link">FAQ</a>
            <a
              href="#join"
              className="btn btn-primary"
              style={{ padding: "11px 22px" }}
              data-testid="nav-join-btn"
            >
              Join the Waitlist
            </a>
          </div>
        </div>
      </nav>

      <header className="hero">
        <div className="blob a" />
        <div className="blob b" />
        <div className="wrap hero-grid">
          <div>
            <span className="pill" data-testid="hero-pill">
              <span className="dot" /> Launching Dec 1, 2026 • Jamaica
            </span>
            <h1 className="title">
              Beauty &amp; wellness, <em>to your door</em> or in-salon.
            </h1>
            <p className="sub">
              Xandi connects you with trusted beauty &amp; wellness providers across Jamaica — book
              in seconds, on your schedule. Join the waitlist and get <strong>15% off</strong> your
              first booking.
            </p>
            <div className="hero-cta">
              <a href="#join" className="btn btn-primary" data-testid="hero-join-btn">
                Join the Waitlist
              </a>
              <a href="#how" className="btn btn-ghost" data-testid="hero-how-btn">
                See how it works
              </a>
            </div>
          </div>
          <Countdown />
        </div>
      </header>

      <section className="block" id="how" data-testid="section-how">
        <div className="wrap">
          <p className="eyebrow">Simple by design</p>
          <h2 className="head">How Xandi works</h2>
          <p className="lead">Three easy steps from "I need this" to "I feel amazing."</p>
          <div className="steps">
            <Reveal className="step">
              <div className="ico">✦</div>
              <h3>Browse providers</h3>
              <p>
                Discover vetted beauty &amp; wellness pros near you — hair, nails, lashes, massage,
                skincare and more.
              </p>
            </Reveal>
            <Reveal className="step">
              <div className="ico">✓</div>
              <h3>Book in seconds</h3>
              <p>
                Pick a time that suits you, choose mobile or in-salon, and confirm. No phone tag,
                no waiting.
              </p>
            </Reveal>
            <Reveal className="step">
              <div className="ico">♡</div>
              <h3>Enjoy your service</h3>
              <p>
                Relax while your provider comes to you — or visit their salon. Rate and rebook your
                favourites.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="block" id="timeline" style={{ paddingTop: 0 }} data-testid="section-timeline">
        <div className="wrap">
          <Reveal className="tl">
            <p className="eyebrow">The roadmap</p>
            <h2 className="head" style={{ marginBottom: 34 }}>
              Our launch timeline
            </h2>
            <div className="tl-grid">
              <div className="phase">
                <div className="mk">1</div>
                <div>
                  <div className="d">Dec 1, 2026</div>
                  <h4>Soft launch</h4>
                  <p>
                    Going live in Kingston &amp; St. Catherine with our founding providers and
                    waitlist members.
                  </p>
                </div>
              </div>
              <div className="phase">
                <div className="mk">2</div>
                <div>
                  <div className="d">Jan 4, 2027</div>
                  <h4>Island-wide launch</h4>
                  <p>
                    Full public launch across Jamaica — more providers, more services, more
                    parishes.
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="block" id="join" style={{ paddingTop: 0 }} data-testid="section-join">
        <div className="wrap">
          <Reveal>
            <Waitlist />
          </Reveal>
        </div>
      </section>

      <section className="block" id="faq" style={{ paddingTop: 0 }} data-testid="section-faq">
        <div className="wrap">
          <p className="eyebrow">Good to know</p>
          <h2 className="head">Frequently asked questions</h2>
          <p className="lead">Everything you need before you join.</p>
          <Faq />
        </div>
      </section>

      <Footer />
      <CookieBanner />
      <ExitIntentModal />
      <StickyMobileCta />
    </>
  );
};

export default Landing;
